import { IconProps } from '@models/icons';

function HomeLineIcon({ size = 16, color }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            className='icon' >
            <path
                d="M6.0769 20.3077H10.1538H13.8461H17.9231C18.4753 20.3077 18.9231 19.86 18.9231 19.3077V11.072C18.9231 10.782 18.7972 10.5062 18.578 10.3163L12.6549 5.18296C12.279 4.85722 11.7209 4.85721 11.3451 5.18296L5.42197 10.3163C5.20281 10.5062 5.0769 10.782 5.0769 11.072V19.3077C5.0769 19.8599 5.52462 20.3077 6.0769 20.3077Z"
                stroke={color} strokeWidth="2"/>
            <path d="M10 12.5H14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default HomeLineIcon;
